var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  "+_vm._s(_vm._T_DB(_vm.address, 'name'))+", "+_vm._s(_vm._T_DB(_vm.address, 'address'))+",\n  "+_vm._s(_vm._T_DB(_vm.address, 'city'))+", "+_vm._s(_vm._T_DB(_vm.address, 'country'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }